export const COLOR_SCHEMES = ['system', 'light', 'dark'] as const;
export const COLOR_SCHEME_MESSAGE_TYPE = 'glomo:color-scheme';
export const APPLIED_COLOR_SCHEME_MESSAGE_TYPE = 'glomo:applied-color-scheme';

export type TColorScheme = (typeof COLOR_SCHEMES)[number];

export type TAppliedColorScheme = Exclude<TColorScheme, 'system'>;

export const isColorScheme = (value: unknown): value is TColorScheme => COLOR_SCHEMES.includes(value as TColorScheme);

export const isAppliedColorScheme = (value: unknown): value is TAppliedColorScheme => value === 'light' || value === 'dark';
